import React from "react";
import "./Preloader.css";

const Preloader = ({ isExiting }) => {
  const mainText = "SOME STUFF";

  return (
    <div className={`preloader-container ${isExiting ? "exiting" : ""}`}>
      <div className="preloader-content-wrapper">
        <div className="preloader-small-text">loading...</div>
        <div className="preloader-main-text">
          {mainText.split("").map((letter, index) => (
            <span
              key={index}
              className="preloader-letter"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {letter === " " ? "\u00A0" : letter}
            </span>
          ))}
        </div>
      </div>
      <div className="loader-bar-container">
        <div className="loader-bar-progress"></div>
      </div>
    </div>
  );
};

export default Preloader;